<template>
    <div class="content">
        <el-card class="box-card">
            <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="60px" class="demo-ruleForm" size="medium">
                <h3 class="title">TCL Alexa Console登录</h3>
                <el-form-item label="邮箱" prop="email">
                    <el-input clearable placeholder="请输入TCL邮箱" type="text" v-model="ruleForm.email" auto-complete="on" :autofocus="true"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pass">
                    <el-input clearable placeholder="请输入密码" type="password" v-model="ruleForm.pass" auto-complete="on"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="vertify">
                    <el-input clearable placeholder="请输入验证码" type="text" :maxlength="codeLength" v-model="ruleForm.vertify" style="width: 44%" @change='isValidate(ruleForm.vertify)'></el-input>
                    <img class="Img" :src="imgSrc" alt="验证码" style="vertical-align:middle" />
                    <el-button class='change' type="text" size="mini" @click.native.prevent="refreshCode">换一张</el-button>
                </el-form-item>
                <el-form-item id="login_button">
                    <el-button type="primary" @click="submitForm('ruleForm')" style='width: 40%'>登录</el-button>
                    <el-button @click="handleUserAdd" style='width: 40%; margin-left: 5%'>注册</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 添加用户界面 -->
        <el-dialog title="用户注册" :visible.sync="addFormVisible" class='modify' width='465px'>
            <el-form :model="addForm" :rules="registerRules" ref="addForm">
                <el-form-item label="邮箱" :label-width="formLabelWidth" prop="email">
                    <el-input placeholder="请输入TCL邮箱" type="text" v-model="addForm.email" auto-complete="off" style="width: 350px"></el-input>
                </el-form-item>
                <!--
                <el-form-item label="部门" :label-width="formLabelWidth" prop="apartment">
                    <el-select v-model="addForm.apartment" placeholder="请选择部门"  auto-complete="off" style="width: 350px">
                        <el-option label="电视应用所" value="电视应用所"></el-option>
                        <el-option label="基础软件所" value="基础软件所"></el-option>
                        <el-option label="SQA测试部" value="SQA测试部"></el-option>
                        <el-option label="TV+" value="TV+"></el-option>
                    </el-select>
                </el-form-item>
                -->
                <el-form-item label="验证码" prop="vertify">
                    <el-input clearable placeholder="请输入验证码" type="text" :maxlength="vertifyLength" v-model="addForm.vertify" style="width: 34%" @change='isValidate(addForm.vertify)'></el-input>
                    <!-- <component :is="sidentify" class="code" :identifyCode="identifyCode"></component> -->
                    <img class="Img" :src="imgSrc" alt="验证码" style="vertical-align:middle" />
                    <el-button class='change' type="text" size="mini" @click.native.prevent="refreshCode">换一张</el-button>
                </el-form-item>
                <el-form-item id="register_button" align="right" style="text-align: center">
                    <el-button @click="cancelForm('addForm')">取 消</el-button>
                    <el-button type="primary" @click="submitAddForm('addForm')">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import { USER_LOGIN } from '../store/modules/user'
    import { Config } from '@/config/config'
    import SIdentify from '../../static/identify'
    import Notify from '../api/notifyMsg'
    import { authen, resetPwd, validateCaptcha } from '../api/user'

    var codeKey = ''
    export default {
        name: 'Login',
        components: {
            SIdentify
        },
        data () {
            var validateEmail = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('邮箱不能为空'))
                } else {
                    var vali = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@tcl.com/
                    if (!vali.test(value)) {
                        callback(new Error('请输入正确的TCL邮箱'))
                    } else {
                        callback()
                    }
                }
            }
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'))
                } else {
                    callback()
                }
            }
            var validateVertify = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入验证码'))
                } else {
                    setTimeout(() => {
                        if (!this.bValidate) {
                            console.log('bValidate' + this.bValidate)
                            callback(new Error('验证码错误'))
                            this.makeCode()
                        } else {
                            callback()
                        }
                    }, 2000)
                }
            }
            var validateDepartment = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择部门'))
                } else {
                    callback()
                }
            }
            return {
                sidentify: SIdentify,
                imgSrc: '',
                ruleForm: {
                    email: '',
                    pass: '',
                    vertify: ''
                },
                rules: {
                    email: [
                        { validator: validateEmail, trigger: 'blur' }
                    ],
                    pass: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    vertify: [
                        { validator: validateVertify, trigger: 'blur' }
                    ]
                },
                registerRules: {
                    email: [
                        { validator: validateEmail, trigger: 'blur' }
                    ],
                    /*apartment: [
                        { validator: validateDepartment, trigger: 'change' }
                    ],*/
                    vertify: [
                        { validator: validateVertify, trigger: 'blur' }
                    ]
                },
                user: {
                    email: '',
                    token: '',
                    expire: '',
                    UID: '',
                    Role: 0
                },
                vertifyLength: 4,
                addFormVisible: false,
                addForm: {
                    email: '',
                    vertify: '',
                    //apartment: ''
                },
                formLabelWidth: '50px',
                codeLength: 4, // 验证码的长度
                bValidate: false
            }
        },
        mounted () {
            this.makeCode()
        },
        watch: {
            'addFormVisible' (newVal, oldVal) { // 监听区域改变
                if (newVal === false) {
                    this.makeCode()
                }
            }
        },
        methods: {
            ...mapActions([USER_LOGIN]),
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.login()
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            },
            handleUserAdd () {
                this.makeCode()
                this.addFormVisible = true
            },
            makeCode () {
                codeKey = Math.random().toString(36).slice(10)
                console.log(codeKey)
                this.imgSrc = Config.url + '/api/v1/captcha?key=' + codeKey + '&length=' + this.codeLength + '&height=' + 36 + '&width=' + 120
            },
            refreshCode () {
                this.makeCode(4)
            },
            login () {
                var _this = this;
                var query = 'key=' + codeKey + '&captcha=' + _this.ruleForm.vertify;
                authen(_this.ruleForm.email, _this.ruleForm.pass, query)
                    //.then(response => response.json())
                    .then(response => {
                        console.log(response)
                        if (response.data.Error_code === 1000) {
                            var userInfo = response.data.User_json
                            _this.user.token = userInfo.Token
                            _this.user.email = userInfo.Email
                            _this.user.expire = userInfo.Expire
                            _this.user.UID = userInfo.Id
                            _this.user.Role = userInfo.Role
                            console.log("user:", _this.user)
                            _this.USER_LOGIN(_this.user)
                            if (this.$route.query.redirect) {
                                _this.$router.replace({
                                    path: this.$route.query.redirect
                                })
                            } else {
                                _this.$router.replace({
                                    path: '/console'
                                })
                            }
                        } else {
                            console.log('error!')
                            Notify.errMsgNotify(response.data.Error_code, this)
                            _this.refreshCode()
                        }
                    })
            },
            setCookieInfo() {
                let _this = this
                let expiredays = 30

                _this.setCookie("cache_account", _this.ruleForm.email, expiredays); //记住账号

                //记住密码
                if (_this.checked === true) {
                    _this.setCookie("cache_pwd", _this.ruleForm.checkPass, expiredays);
                    _this.setCookie("cache_pwd_checked", true, expiredays); //勾选状态
                } else {
                    _this.setCookie("cache_pwd", "", expiredays);
                    _this.setCookie("cache_pwd_checked", false, expiredays); //未勾选状态
                }
            },
            submitAddForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.register(formName)
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            },
            register (formName) {
                var _this = this;
                this.addFormVisible = false;
                var query = 'key=' + codeKey + '&captcha=' + _this.addForm.vertify;
                resetPwd(_this.addForm.email, /*_this.addForm.apartment,*/ query)
                    //.then(response => response.json())
                    .then(response => {
                        console.log(response)
                        if (response.data.Error_code === 1000) {
                            _this.$message({
                                type: 'success',
                                message: '注册成功，密码请查收邮箱！'
                            })
                        } else {
                            console.log('error!')
                            Notify.errMsgNotify(json.Error_code, this)
                        }
                    })
                this.$refs[formName].resetFields()
            },
            cancelForm (formName) {
                this.addFormVisible = false
                this.$refs[formName].resetFields()
            },
            isValidate (inputCode) {
                let _this = this
                _this.bValidate = false
                if (inputCode !== '' && inputCode.length === _this.codeLength) {
                    var query = 'key=' + codeKey + '&captcha=' + inputCode;
                    validateCaptcha(query)
                        //.then(response => response.json())
                        .then(response => {
                            console.log(response)
                            if (response.data.Error_code === 1000) {
                                _this.bValidate = true
                                console.log(_this.bValidate)
                            } else {
                                _this.bValidate = false
                                console.log(_this.bValidate)
                                Notify.errMsgNotify(response.data.Error_code, this)
                            }
                        })
                }
            }
        }
    }
</script>

<style>
    .box-card {
        width: 480px;
        text-align: center;
        margin: 0 auto;
        margin-top: 100px;
    }
    .content {
        text-align: center;
        /*display:flex;
        align-items: center;/*水平居中*/
        /*justify-content: center;/*垂直居中*/
        /*width:100%;
        height:100%;*/
    }
    .title {
        color: #717171;
    }
    /*.el-form-item {
        text-align: left;
    }
    /*.el-input {
        float: left;
    }
    #button {
        text-align: center;
    }*/
    .code {
        float: left;
        margin-left: 23px;
        height: 36px;
    }
    .change {
        margin-left: 23px;
    }
    .Img {
        margin-left: 23px;
    }
    #button {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/NewLogin.vue